import * as React from "react";
import { useHistory } from "react-router";

import { Button } from "@livechat/design-system-react-components";

import Flex from "components/layout/Flex";
import Text from "components/layout/Text";
import ApplicationSettingsContainer from "routes/settings/integrations/components/ApplicationSettingsContainer";
import { ContentWrapper, PageWrapper } from "routes/settings/styled";
import { ApplicationWidgetPlacement, IApplication } from "store/entities/applications/interfaces";

import FinishInstallation from "./FinishInstallation";

interface IProps {
  application: IApplication;
}

const DefaultSettings: React.FC<IProps> = ({ application }) => {
  const history = useHistory();

  const { name, tutorialUrl, elements } = application;

  const widgets = Object.values(elements?.widgets || {});
  const fullscreenWidget = widgets.find(({ placement }) => placement === ApplicationWidgetPlacement.FullScreen);

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const openWidget = () => history.push(`/applications/${fullscreenWidget?.id}`);
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const openTicketsView = () => history.push("/tickets");

  const applicationLocationInfo = fullscreenWidget
    ? "You can now access it from the main menu on the left."
    : "You can now access it in the ticket details.";

  return (
    <ApplicationSettingsContainer application={application}>
      <PageWrapper>
        <ContentWrapper>
          <Text fontSize="14px" lineHeight="20px">
            Thank you for installing <strong>{name}</strong>. {applicationLocationInfo}
          </Text>

          <Flex marginTop="24px" gap="16px" alignItems="center">
            {fullscreenWidget ? (
              <Button kind="primary" onClick={openWidget}>
                Open App
              </Button>
            ) : (
              <Button kind="primary" onClick={openTicketsView}>
                Go to Tickets section
              </Button>
            )}

            {tutorialUrl && (
              <Button kind="plain" href={tutorialUrl} rel="noopener noreferrer" target="_blank">
                Browse tutorial
              </Button>
            )}
          </Flex>

          <FinishInstallation application={application} />
        </ContentWrapper>
      </PageWrapper>
    </ApplicationSettingsContainer>
  );
};

export default DefaultSettings;
